import './style/footer.less'
import $ from 'jquery'
import footLinks from './js/footer'

/**
 * 首页底部
 */
module.exports = {
    init: (config) => {

        // 初始化顶部站点导航
        config.container = $('#channel-footer');
        footLinks.init(config.container);
    }
}


// WEBPACK FOOTER //
// ./modules/footer-channel/index.js